import { ATTENTION_REQUIRED } from "./generalConstants";

// Defines routes for all iBuy webpages
export const HOMEPAGE = "/";
export const APPROVALS = "/approvals";
export const CART_PREFIX = "/cart/";
export const ONE_TIME_ADDRESSES = "/addresses";
export const INVOICE_SUMMARY = "/invoice";
export const PO_SUMMARY = "/po-summary";
export const PO_SUMMARY_SETTER = "/po-summary/:poNumber";
export const PROCUREMENT_MANAGER_ADMIN = "/procurementAdmin";
export const PRODUCT_RESULTS = "/product-results";
export const PRODUCT_DETAILS = "/product-details/:id";
export const PUNCHOUT_RESULTS = "/punchout-results/";
export const RECEIPTS = "/receipts";
export const REQUISITIONS = "/requisitions";
export const CART_ROUTE_SETTER = "/cart/:cartKey";
export const INVOICE_SUMMARY_SETTER = "/invoice/:invoiceId";
export const SMART_FORM_DETAILS = "/smart-form-details/:id";
export const REQUISITION_SUMMARY = "/requisition-summary/:requisitionNumber";
export const PAGE_NOT_FOUND = "*";

export const INVOICE_SUMMARY_PAGE = (invoiceId) =>
    `${INVOICE_SUMMARY}/${invoiceId}`;
export const PRODUCT_DETAILS_PAGE = (id) => `/product-details/${id}`;
// `orgId` is optional. When supplied (e.g. the caller already knows which
// OU the PO belongs to — such as a link out of a requisition summary), it
// is forwarded to the PO API as `?org_id=…`, allowing the API to resolve
// the PO unambiguously and suppressing the OU chooser modal on the
// destination page (see `PoSummaryPage` / `MultipleOuMatchesError`).
export const PO_SUMMARY_PAGE = (poNumber, orgId) =>
    orgId != null
        ? `${PO_SUMMARY}/${poNumber}?org_id=${encodeURIComponent(orgId)}`
        : `${PO_SUMMARY}/${poNumber}`;
export const RECEIPTS_PRIORITISED = (receiptsNotificationCount) =>
    `${RECEIPTS}${
        receiptsNotificationCount > 0
            ? `?receiptReqStatus=${ATTENTION_REQUIRED}`
            : ""
    }`;
export const REQ_RECEIPT_SUMMARY = (id) =>
    `${RECEIPTS}?mode=ALL_PERMITTED&&requisitionId=${id}`;
export const REQUISITION_SUMMARY_PAGE = (requisitionNumber) =>
    `/requisition-summary/${requisitionNumber}`;
export const SMART_FORM_DETAILS_PAGE = (id) => `/smart-form-details/${id}`;
